import { appendAcuteToxicity } from './appendAcuteToxicity.js';
import { appendLongTermToxicity } from './appendLongTermToxicity.js';
import { appendMiscellaneous } from './appendMiscellaneous.js';
import { appendReactivityAndInstability } from './appendReactivityAndInstability.js';
import { appendVolumeAndFlammability } from './appendVolumeAndFlammability.js';
import { prepareReagents } from './normalize/prepareReagents.js';

export async function calculateSafety(originalReagents, options = {}) {
  const reagents = await prepareReagents(originalReagents, options);
  const report = { scores: {} }
  appendAcuteToxicity(reagents, report, options);
  appendReactivityAndInstability(reagents, report, options);
  appendVolumeAndFlammability(reagents, report, options);
  appendLongTermToxicity(reagents, report, options);
  appendMiscellaneous(reagents, report, options);

  report.finalScore = Object.values(report.scores).reduce((sum, score) => sum + score, 0) + report.miscellaneous.reduce((sum, misc) => sum + misc.score, 0);

  const hasRed = report.redAcuteToxicity.length > 0 || report.redReactivityAndInstabilities.length > 0
  if (report.finalScore <= 12 && !hasRed) {
    report.class = 1;
  } else if (report.finalScore > 18) {
    report.class = 3;
  } else {
    report.class = 2
  }


  return { reagents, report };
}
